export default __webpack_public_path__ + "static/media/nightw.91c987f4.gif";